import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Eye, EyeOff, Loader2, Utensils } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import { mensajeError } from '../api/client'
import { alerta } from '../utils/alertas'

export function Login() {
  const { iniciarSesion, iniciarSesionPin, cargando } = useAuth()
  // const { tema, cambiarTema } = useTema()
  const navegar = useNavigate()

  const [modoPin] = useState(false)
  const [usuario, setUsuario] = useState('admin@logistica.red')
  const [password, setPassword] = useState('')
  const [mostrarPassword, setMostrarPassword] = useState(false)
  const [empresa, setEmpresa] = useState('DEMO')
  const [pin, setPin] = useState('')
  const [sucursal, setSucursal] = useState(1)

  const entrar = async (e: FormEvent) => {
    e.preventDefault()
    try {
      if (modoPin) await iniciarSesionPin(pin, empresa, sucursal)
      else await iniciarSesion(usuario, password, empresa)
      const rutaGuardada = localStorage.getItem('logistica:ultima-ruta')
      navegar(rutaGuardada || '/')
    } catch (error) {
      await alerta.error('No se pudo iniciar sesion', mensajeError(error))
    }
  }

  return (
    <div className="grid min-h-full place-items-center p-5 bg-fondo text-texto">
      <form
        className="tarjeta w-full max-w-md anima-crecer"
        onSubmit={entrar}
      >
        <div className="mb-4 text-center">
          <div className="mx-auto mb-3 grid h-16 w-16 place-items-center rounded-2xl bg-gradient-to-br from-accent to-accent-soft text-white">
            <Utensils size={28} />
          </div>
          <h2 className="m-0 text-2xl font-bold">Logística</h2>
          <p className="texto-suave">
            {modoPin ? 'Acceso rapido con PIN' : 'Ingresa con tu cuenta'}
          </p>
        </div>

        <div className="campo">
          <label htmlFor="empresa">Codigo de empresa</label>
          <input id="empresa" value={empresa} onChange={(e) => setEmpresa(e.target.value.toUpperCase())} required />
        </div>

        {modoPin ? (
          <>
            <div className="campo">
              <label htmlFor="sucursal">Sucursal</label>
              <input id="sucursal" type="number" min={1} value={sucursal} onChange={(e) => setSucursal(Number(e.target.value))} />
            </div>
            <div className="campo">
              <label htmlFor="pin">PIN</label>
              <input
                id="pin"
                type="password"
                inputMode="numeric"
                maxLength={8}
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                required
                className="text-center text-xl tracking-widest"
              />
            </div>
          </>
        ) : (
          <>
            <div className="campo">
              <label htmlFor="usuario">Correo o telefono</label>
              <input id="usuario" value={usuario} onChange={(e) => setUsuario(e.target.value)} required autoComplete="username" />
            </div>
            <div className="campo">
              <label htmlFor="password">Contrasena</label>
              <div className="relative">
                <input
                  id="password"
                  type={mostrarPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setMostrarPassword((v) => !v)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-texto-suave hover:text-texto"
                  title={mostrarPassword ? 'Ocultar contrasena' : 'Mostrar contrasena'}
                >
                  {mostrarPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
          </>
        )}

        <div className="flex justify-center">
          <button className="pl-4 pr-4 pt-1 pb-1 bg-tema text-white rounded-full hover:bg-tema/90 transition-colors disabled:opacity-50 flex items-center gap-2" type="submit" disabled={cargando}>
            {cargando ? <><Loader2 className="animate-spin" size={16} /> Ingresando...</> : 'Ingresar'}
          </button>
        </div>

        {/* <button
          type="button"
          className="btn btn-plano mt-2.5 w-full"
          onClick={() => setModoPin((v) => !v)}
        >
          {modoPin ? 'Usar usuario y contrasena' : 'Usar PIN'}
        </button> */}

        {/* <div className="mt-4 flex flex-wrap justify-center gap-2">
          {TEMAS.map((t) => (
            <button
              key={t.valor}
              type="button"
              title={t.nombre}
              onClick={() => cambiarTema(t.valor as Tema)}
              className="h-6 w-6 rounded-full border-2 cursor-pointer transition-transform hover:scale-110"
              style={{
                background: t.muestra,
                borderColor: tema === t.valor ? 'var(--accent)' : 'var(--borde)'
              }}
            />
          ))}
        </div> */}
      </form>
    </div>
  )
}
